import React from 'react';

import { faRefresh, faWarning } from '@fortawesome/pro-solid-svg-icons';
import { makeStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import { Button, Divider, Paper, Typography } from '@mui/material';

import { FontAwesomeSvgIcon } from '../index';

const useStyle = makeStyles((theme) => ({
  headerAlignment: {
    display: 'flex',
    padding: theme.spacing(2),
    gap: theme.spacing(2)
  },
  contentAlignment: { padding: theme.spacing(2) },
  actionAlignment: {
    display: 'flex',
    justifyContent: 'end',
    padding: theme.spacing(2)
  }
}));

interface LoadingError {
  reFetch?: (props?: any) => unknown;
  content?: string;
}

export const LoadingError: React.FC<LoadingError> = ({ reFetch, content }) => {
  const { t } = useTranslation();
  const classes = useStyle();

  return (
    <Paper>
      <div className={classes.headerAlignment}>
        <FontAwesomeSvgIcon icon={faWarning} color={'warning'} />
        <Typography variant="h1">{t('loadingError.header')}</Typography>
      </div>
      <Divider />
      <Typography variant="body1" className={classes.contentAlignment}>
        {content ?? t('loadingError.contentDefault')}
      </Typography>
      <div className={classes.actionAlignment}>
        <Button variant="contained" color={'warning'} onClick={reFetch}>
          <FontAwesomeSvgIcon icon={faRefresh} />
        </Button>
      </div>
    </Paper>
  );
};
